import { useMemo, useRef } from "react";
import { useElementDimensions } from "@/hooks/use-element-dimensions";
import type { TimeAxisPanelSpec } from "../ChartSpec";
import { useSpec } from "../spec/spec-context";
import { computeGridMargins } from "./build-time-panel-options";
import { Panel } from "./panel";

export function PanelStack() {
    const { spec } = useSpec();
    const stackRef = useRef<HTMLDivElement | null>(null);
    const { dimensions: stackDimensions } = useElementDimensions({ ref: stackRef });

    const gridMargins = useMemo(() => {
        let left = 0;
        let right = 0;
        spec.panels.forEach((panel) => {
            const margins = computeGridMargins(panel.axes);
            left = Math.max(left, margins.left);
            right = Math.max(right, margins.right);
        });
        return { left, right };
    }, [spec.panels]);

    /* TODO: maybe some css styling to better handle multiple panels? */
    return (
        <div ref={stackRef} className={"w-full"}>
            {spec.panels.map((panel) => (
                // TODO: Add guards for various panel types
                <Panel
                    key={panel.id}
                    spec={panel as TimeAxisPanelSpec}
                    gridMargins={gridMargins}
                    maxStackWidth={stackDimensions.width}
                />
            ))}
        </div>
    );
}
